import { captureException } from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { redeemRedemptionCode } from 'typescript/clients/redeem/redeem_client';
import { MUTATION_KEYS } from 'typescript/constants/react_query';

export const useRedeemRedemptionCode = () => {
  const { mutate: redeemCode, ...rest } = useMutation({
    mutationKey: [MUTATION_KEYS.REDEEM_REDEMPTION_CODE],
    mutationFn: redeemRedemptionCode,
    onError: (error) => {
      captureException(error);
    },
  });

  return { redeemCode, ...rest };
};
